import { IBrand } from "./IBrand";

export type BrandMap = Map<string, Map<string, IBrand>>;
